import React, { Component } from 'react';
import {
    Button, TextField, Checkbox, FormControlLabel,
    Table, TableBody, TableCell, TableContainer, TableHead, TableRow,
    Paper, Select, MenuItem, InputLabel, FormControl, TextareaAutosize,
    Dialog, DialogActions, DialogContent, DialogTitle, Tooltip
} from '@mui/material';
import IconButton from '@mui/material/IconButton';
import DeleteIcon from '@mui/icons-material/Delete';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import { red } from '@mui/material/colors';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import '../CSS/Settings.css';
import { deleteRecord, getSettingSpaces, createNewSpace, getSitePrice, updateSpace } from '../utils/OpenCampground_Database_Calls';
import { withStyles } from '@material-ui/core/styles';
import { styled } from '@mui/material/styles';
import Alert from '@mui/material/Alert';
import Stack from '@mui/material/Stack';
import { Snackbar, Collapse } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import { Upload } from 'lucide-react';
import { Edit as EditIcon, Check as CheckIcon } from "@mui/icons-material";


const VisuallyHiddenInput = styled('input')({
    clip: 'rect(0 0 0 0)',
    clipPath: 'inset(50%)',
    height: 1,
    overflow: 'hidden',
    position: 'absolute',
    bottom: 0,
    left: 0,
    whiteSpace: 'nowrap',
    width: 1,
});


const useStyles = theme => ({
    dialogPaper: {
        padding: theme.spacing(2),
        borderRadius: '10px',
    }
});

const theme = createTheme({
    palette: {
        primary: {
            main: '#2dcd7a',
        },
    },
});

class Spaces extends Component {
    constructor(props) {
        super(props);
        this.state = {
            spaces: [],
            spacesUpdate: false,
            sites: [],
            prices: [],
            formValid: false,
            spaceName: '',
            e15a: false,
            e30a: false,
            e50a: false,
            water: false,
            sewer: false,
            siteType: '',
            price: '',
            remote: true,
            len: '0',
            width: '102',
            addNew: false,
            editMode: false,
            editingSpace: null,
            special_condition: '',
            image_url: null,
            image_url_2: null,
            active_image: 0,
            alertMessage: "",
            alertType: "",
            image_name_1: "",
            image_name_2: "",
            viewImage: false,
            viewImage1: "",
            viewImage2: "",
            active: false,
            open: false,
            popupTitle: '',
            popupText: '',
            deleteId: '',
            confirmOpen: false,
            confirmPopupTitle: 'Delete Space',
            ConfirmPopupText: 'Please make sure that the space that you are deleting is not associated with any of the current or future reservations.',
            custom_descriptions: [""],
            selectedDescription: [],
            isOpen: false,
            editEminities: null,
        };
    }

    async componentDidMount() {
        let getSitePriceData = await getSitePrice(this.props.user, this.props.serverName);
        this.setState({
            sites: getSitePriceData[0],
            prices: getSitePriceData[1]
        });
        this.spaces();
    }

    new = async () => {
        this.setState({
            addNew: true
        });
    }

    // handleFieldChange = (index, value) => {
    //     const custom_descriptions = [...this.state.custom_descriptions];
    //     custom_descriptions[index] = value;
    //     this.setState({ custom_descriptions });
    // };
    
    // handleAddField = () => {
    //     if (this.state.custom_descriptions?.length < 10) {
    //       this.setState({ custom_descriptions: [...this.state.custom_descriptions, ""] });
    //     }
    // };
    
    // handleRemoveField = (index) => {
    //     const { custom_descriptions, selectedDescription } = this.state;
    //     const newFields = custom_descriptions.filter((_, i) => i !== index);
    //     const updatedSelectedDescription = custom_descriptions[index] === selectedDescription ? null : selectedDescription;
    
    //     this.setState({ custom_descriptions: newFields, selectedDescription: updatedSelectedDescription });
    // };
    
    // handleCheckboxChange = (index) => {
    //     const { custom_descriptions, selectedDescription } = this.state;
    //     const newSelectedDescription = custom_descriptions[index] === selectedDescription ? null : custom_descriptions[index];
    
    //     this.setState({ selectedDescription: newSelectedDescription });
    // };
    
    // toggleCollapse = () => {
    //     this.setState((prevState) => ({ isOpen: !prevState.isOpen }));
    // };

    handleFieldChange = (index, value) => {
        // const updatedDescriptions = [...this.state.custom_descriptions];
        // updatedDescriptions[index] = value;
        // this.setState({ custom_descriptions: updatedDescriptions });
        const capitalizedValue = value.charAt(0).toUpperCase() + value.slice(1); // Capitalize first letter
        const updatedDescriptions = [...this.state.custom_descriptions];
        updatedDescriptions[index] = capitalizedValue;
        this.setState({ custom_descriptions: updatedDescriptions });
      };
    
      handleAddField = () => {
        if (this.state.custom_descriptions.length < 10) {
          this.setState((prevState) => ({
            custom_descriptions: [...prevState.custom_descriptions, ""],
          }));
        }
      };
    
      handleRemoveField = (index) => {
        const { custom_descriptions, selectedDescription } = this.state;
        const updatedDescriptions = custom_descriptions.filter((_, i) => i !== index);
        const updatedSelectedDescription =
        custom_descriptions[index] === selectedDescription ? null : selectedDescription;
    
        this.setState({
            custom_descriptions: updatedDescriptions,
            selectedDescription: updatedSelectedDescription,
        });
      };
    
    //   handleCheckboxChange = (index) => {
    //     this.setState((prevState) => ({
    //       selectedDescription:
    //         prevState.custom_descriptions[index] === prevState.selectedDescription ? null : prevState.custom_descriptions[index],
    //     }));
    //   };

    handleCheckboxChange = (index) => {
        this.setState((prevState) => {
          const selectedDescriptions = [...prevState.selectedDescription]; // Copy the current selections
          const fieldValue = prevState.custom_descriptions[index]; // Get the value at the selected index
      
          if (selectedDescriptions.includes(fieldValue)) {
            // If already selected, remove it
            return { selectedDescription: selectedDescriptions.filter((desc) => desc !== fieldValue) };
          } else {
            // If not selected, add it
            return { selectedDescription: [...selectedDescriptions, fieldValue] };
          }
        });
    };
    
      toggleCollapse = () => {
        this.setState((prevState) => ({ isOpen: !prevState.isOpen }));
      };
    
      toggleEditMode = (index) => {
        this.setState((prevState) => ({
            editEminities: prevState.editEminities === index ? null : index,
        }));
      };

    handleChange = (event) => {
        const { id, checked, value } = event.target;

        if (['e15a', 'e30a', 'e50a', 'water', 'sewer', 'remote', 'active'].includes(id)) {
            this.setState({ [id]: checked });
            console.log(id, checked);
        } else if (id === 'active_image') {
            this.setState({ [id]: checked ? 1 : 0 });
        } else {
            this.setState({ [id]: value }, () => {
                this.formValidation();
            });
        }
    };

    handleImageChange1 = (event) => {
        const file = event.target.files[0];

        if (!file) return;

        const maxSize = 500 * 1024;
        if (file.size > maxSize) {
            this.setState({
                alertMessage: "File size must be less than 500KB.",
                alertType: "error"
            });
            return;
        }

        const img = new Image();
        img.src = URL.createObjectURL(file);

        img.onload = () => {
            const { width, height } = img;

            if (width < 800 || height < 600 || width > 1600 || height > 1200) {
                this.setState({
                    alertMessage: "Image dimensions must be between 800x600px and 1600x1200px.",
                    alertType: "error"
                });
                return;
            }
            console.log(file + 'uploaded file to console');
            this.setState({
                image_url: file,
                alertMessage: "Image uploaded successfully!",
                alertType: "success",
                image_name_1: file.name
            });
        };

        img.onerror = () => {
            this.setState({
                alertMessage: "Invalid image file.",
                alertType: "error"
            });
        };
    };

    handleImageChange2 = (event) => {
        const file = event.target.files[0];
        if (!file) return;

        const maxSize = 3 * 1024 * 1024;
        if (file.size > maxSize) {
            this.setState({
                alertMessage: "File size must be less than 500KB.",
                alertType: "error"
            });
            return;
        }

        const img = new Image();
        img.src = URL.createObjectURL(file);

        img.onload = () => {
            const { width, height } = img;

            if (width < 800 || height < 600 || width > 1600 || height > 1200) {
                this.setState({
                    alertMessage: "Image dimensions must be between 800x600px and 1600x1200px.",
                    alertType: "error"
                });
                return;
            }

            this.setState({
                image_url_2: file,
                alertMessage: "Image uploaded successfully!",
                alertType: "success",
                image_name_2: file.name
            });
        };

        img.onerror = () => {
            this.setState({
                alertMessage: "Invalid image file.",
                alertType: "error"
            });
        };
    };

    formValidation = () => {
        const { spaceName, siteType, price, len, width } = this.state;
        if (spaceName && siteType && price && len && width) {
            this.setState({
                formValid: true
            });
        } else if (this.state.formValid) {
            this.setState({
                formValid: false
            });
        }
    }

    deleteRecord = async (data) => {
        await deleteRecord(this.props.user, this.props.serverName, "spaces", data);
        this.setState({
            spacesUpdate: true,
            open: true,
            popupTitle: 'Delete Space',
            popupText: 'Space deleted successfully.'
        });
        this.spaces();
    }

    spaces = async () => {
        if (this.state.spacesUpdate) {
            let getSpaceData = await getSettingSpaces(this.props.user, this.props.serverName);
            this.setState({
                spaces: getSpaceData
            });
        } else {
            if (this.state.spaces.length === 0) {
                let getSpaceData = await getSettingSpaces(this.props.user, this.props.serverName);
                this.setState({
                    spaces: getSpaceData
                });
            }
        }
    }

    addNew = async () => {
        let spaceExists = this.state.spaces.some(space => space.name.trim().toLowerCase() === this.state.spaceName.trim().toLowerCase());
        if (spaceExists) {
            this.setState({
                open: true,
                popupText: 'This space name already exists. Please choose a different name.'
            })
            return;
        }

        let siteId = this.state.sites.find(site => site.name === this.state.siteType)?.id;
        let priceId = this.state.prices.find(price => price.name === this.state.price)?.id;
        try {
            const result = await createNewSpace(this.props.user, this.props.serverName, this.state.spaceName, this.state.e15a, this.state.e30a, this.state.e50a,
                this.state.water, this.state.sewer, this.state.len, this.state.width, siteId, priceId, this.state.remote, this.state.special_condition, this.state.active, this.state.image_url, this.state.image_url_2, this.state.active_image, JSON.stringify(this.state.custom_descriptions), JSON.stringify(this.state.selectedDescription));
            if (result) {
                this.setState({
                    spacesUpdate: true,
                    addNew: false,
                    spaceName: '',
                    e15a: false,
                    e30a: false,
                    e50a: false,
                    water: false,
                    sewer: false,
                    siteType: '',
                    price: '',
                    remote: true,
                    len: '0',
                    width: '102',
                    special_condition: '',
                    active: false,
                    image_url: null,
                    image_url_2: null,
                    active_image: 0,
                    image_name_1: "",
                    image_name_2: "",
                    custom_descriptions: [""],
                    selectedDescription: [],
                    isOpen: false,
                    popupTitle: 'New Space',
                    popupText: 'New space added successfully.',
                    open: true
                });
                this.spaces();
            }
            else {
                throw new Error("Add failed: No response from server.");
            }

        } catch (err) {
            this.setState({
                open: true,
                popupTitle: 'Error',
                popupText: 'Failed to Add space. Please try again.'
            });
        }
    }

    updateSpace = async () => {
        let siteId = this.state.sites.find(site => site.name === this.state.siteType)?.id;
        let priceId = this.state.prices.find(price => price.name === this.state.price)?.id;
        try {
            let result = await updateSpace(this.props.user, this.props.serverName, this.state.spaceName, this.state.e15a, this.state.e30a, this.state.e50a,
                this.state.water, this.state.sewer, this.state.len, this.state.width, siteId, priceId, this.state.remote, this.state.editingSpace.id, this.state.special_condition, this.state.active, this.state.image_url, this.state.image_url_2, this.state.active_image, JSON.stringify(this.state.custom_descriptions), JSON.stringify(this.state.selectedDescription));
            console.log(result)
            if (result) {
                this.setState({
                    spacesUpdate: true,
                    editMode: false,
                    editingSpace: null,
                    addNew: false,
                    spaceName: '',
                    e15a: false,
                    e30a: false,
                    e50a: false,
                    water: false,
                    sewer: false,
                    siteType: '',
                    price: '',
                    remote: true,
                    len: '0',
                    width: '102',
                    special_condition: '',
                    active: false,
                    image_url: null,
                    image_url_2: null,
                    image_name_1: "",
                    image_name_2: "",
                    active_image: 0,
                    custom_descriptions: [""],
                    selectedDescription: [],
                    isOpen: false,
                    open: true,
                    popupTitle: 'Edit Space',
                    popupText: 'Space updated successfully.'
                });
                this.spaces();
            }
            else {
                throw new Error("Update failed: No response from server.");
            }

        } catch (err) {
            this.setState({
                open: true,
                popupTitle: 'Error',
                popupText: 'Failed to update space. Please try again.'
            });
        }
    }

    siteChange = (event) => {
        this.setState({
            siteType: event.target.value
        }, () => {
            this.formValidation();
        });
    };

    priceChange = (event) => {
        this.setState({
            price: event.target.value
        }, () => {
            this.formValidation();
        });
    };

    editSpace = (space) => {
        this.setState({
            editMode: true,
            addNew: false,
            editingSpace: space,
            spaceName: space.name,
            e15a: space.power_15a,
            e30a: space.power_30a,
            e50a: space.power_50a,
            water: space.water,
            sewer: space.sewer,
            siteType: space.site_name,
            price: space.price_name,
            remote: space.remote_reservable,
            len: space.length,
            width: space.width,
            special_condition: space.special_condition,
            active: space.active,
            image_url: space?.image_url,
            image_url_2: space?.image_url_2,
            active_image: space?.active_image,
            custom_descriptions: space?.custom_eminities,
            selectedDescription: space?.selected_eminities
        });
    }

    cancelEdit = () => {
        this.setState({
            editMode: false,
            editingSpace: null,
            spaceName: '',
            e15a: false,
            e30a: false,
            e50a: false,
            water: false,
            sewer: false,
            siteType: '',
            price: '',
            remote: true,
            len: '0',
            width: '102',
            special_condition: '',
            active: false,
            image_url: null,
            image_url_2: null,
            active_image: 0,
            image_name_1: "",
            image_name_2: "",
            custom_descriptions: [""],
            selectedDescription: [],
            isOpen: false,
        });
    }

    handleCancel = () => {
        this.setState({ open: false });
    };

    render() {
        const { classes } = this.props;
        const { custom_descriptions, selectedDescription, isOpen, editEminities } = this.state;
        return (
            <ThemeProvider theme={theme}>
                <Snackbar
                    open={Boolean(this.state.alertMessage)}
                    autoHideDuration={3000}
                    onClose={() => this.setState({ alertMessage: "", alertType: "" })}
                    anchorOrigin={{ vertical: "top", horizontal: "center" }}
                >
                    <Alert severity={this.state.alertType} onClose={() => this.setState({ alertMessage: "", alertType: "" })}>
                        {this.state.alertMessage}
                    </Alert>
                </Snackbar>
                <Dialog open={this.state.viewImage} onClose={() => this.setState({ viewImage: false })} maxWidth="md" fullWidth>
                    {/* <DialogTitle>View Images</DialogTitle> */}
                    <DialogContent style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                        {this.state.viewImage1 ? (
                            <div style={{ marginBottom: "15px", textAlign: "center" }}>
                                <h4>Main Image</h4>
                                <img src={this.state.viewImage1} alt="Main" style={{ maxWidth: "100%", maxHeight: "400px", borderRadius: "10px" }} />
                            </div>
                        ) : (
                            <p>No main image available</p>
                        )}
                        {this.state.viewImage2 ? (
                            <div style={{ textAlign: "center" }}>
                                <h4>Secondary Image</h4>
                                <img src={this.state.viewImage2} alt="Secondary" style={{ maxWidth: "100%", maxHeight: "400px", borderRadius: "10px" }} />
                            </div>
                        ) : (
                            <p>No secondary image available</p>
                        )}
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={() => this.setState({ viewImage: false })} style={{ backgroundColor: "#2dcd7a", color: "#000", padding: "8px 20px", borderRadius: "10px" }}>
                            Close
                        </Button>
                    </DialogActions>
                </Dialog>
                <Dialog open={this.state.confirmOpen} onClick={() => this.setState({ confirmOpen: false })} classes={{ paper: classes.dialogPaper }}>
                    <DialogTitle>{this.state.confirmPopupTitle}</DialogTitle>
                    <DialogContent>
                        {this.state.ConfirmPopupText}
                    </DialogContent>
                    <DialogActions style={{ display: 'flex', justifyContent: 'space-between' }}>
                        <Button onClick={() => this.setState({ confirmOpen: false })} style={{ backgroundColor: '#FDECEB', color: '#DB3737', padding: '2% 10% 2% 10%', margin: '0 0 0 2%', borderRadius: '10px', marginTop: '3%' }}>
                            Cancel
                        </Button>
                        <Button onClick={() => this.deleteRecord(this.state.deleteId)} style={{ backgroundColor: '#2dcd7a', color: '#000000', padding: '2% 10% 2% 10%', margin: '0 0 0 2%', borderRadius: '10px', marginTop: '3%' }}>
                            Confirm
                        </Button>
                    </DialogActions>
                </Dialog>
                <Dialog open={this.state.open} onClose={this.handleCancel} classes={{ paper: classes.dialogPaper }}>
                    <DialogTitle>{this.state.popupTitle}</DialogTitle>
                    <DialogContent>
                        {this.state.popupText}
                    </DialogContent>
                    <DialogActions style={{ display: 'flex', justifyContent: 'space-between' }}>
                        <Button onClick={this.handleCancel} style={{ backgroundColor: '#FDECEB', color: '#DB3737', padding: '2% 10% 2% 10%', margin: '0 0 0 2%', borderRadius: '10px', marginTop: '3%' }}>
                            Close
                        </Button>
                    </DialogActions>
                </Dialog>
                <Button className='resButton' onClick={this.new} style={{ backgroundColor: '#2dcd7a', color: '#000000', marginBottom: '2%', textTransform: "capitalize" }}>
                    Add New Space
                </Button>
                {this.state.addNew || this.state.editMode
                    ?
                    <>
                        <Dialog open={this.state.addNew || this.state.editMode} onClose={() => { this.setState({ addNew: false, editMode: false }); }} maxWidth="sm" fullWidth>
                            <DialogContent dividers>
                                <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
                                    <h2 style={{ margin: "0px", marginBottom: "10px" }}>{this.state.editMode ? "Update Space" : "Add Space"}</h2>
                                    <div style={{ display: 'flex', alignItems: 'center', gap: '16px', width: '100%' }}>
                                        <TextField
                                            id="spaceName"
                                            required
                                            label="Space Name"
                                            value={this.state.spaceName}
                                            onChange={this.handleChange}
                                            sx={{ width: "100%" }}
                                        />
                                    </div>
                                    <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
                                        <FormControlLabel
                                            label={"Power 15a"}
                                            control={
                                                <Checkbox
                                                    id="e15a"
                                                    checked={this.state.e15a}
                                                    onChange={this.handleChange}
                                                />
                                            }
                                        />
                                        <FormControlLabel
                                            label={"Power 30a"}
                                            control={
                                                <Checkbox
                                                    id="e30a"
                                                    checked={this.state.e30a}
                                                    onChange={this.handleChange}
                                                />
                                            }
                                        />
                                        <FormControlLabel
                                            label={"Power 50a"}
                                            control={
                                                <Checkbox
                                                    id="e50a"
                                                    checked={this.state.e50a}
                                                    onChange={this.handleChange}
                                                />
                                            }
                                        />
                                    </div>
                                    <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
                                        <FormControlLabel
                                            label={"Water"}
                                            control={
                                                <Checkbox
                                                    id="water"
                                                    checked={this.state.water}
                                                    onChange={this.handleChange}
                                                />
                                            }
                                        />
                                        <FormControlLabel
                                            label={"Sewer"}
                                            control={
                                                <Checkbox
                                                    id="sewer"
                                                    checked={this.state.sewer}
                                                    onChange={this.handleChange}
                                                />
                                            }
                                        />
                                    </div>
                                    <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
                                        <FormControl style={{ width: '50%' }}>
                                            <InputLabel>Site Type</InputLabel>
                                            <Select
                                                labelId="site"
                                                id="siteSelect"
                                                value={this.state.siteType}
                                                label="Site Type"
                                                onChange={this.siteChange}
                                            >
                                                {this.state.sites.map((site, index) => (
                                                    <MenuItem key={index} value={site.name}>
                                                        {site.name}
                                                    </MenuItem>
                                                ))}
                                            </Select>
                                        </FormControl>
                                        <FormControl style={{ width: '50%' }}>
                                            <InputLabel>Price Class</InputLabel>
                                            <Select
                                                labelId="price"
                                                id="priceSelect"
                                                value={this.state.price}
                                                label="Price Class"
                                                onChange={this.priceChange}
                                            >
                                                {this.state.prices.map((price, index) => (
                                                    <MenuItem key={index} value={price.name}>
                                                        {price.name}
                                                    </MenuItem>
                                                ))}
                                            </Select>
                                        </FormControl>
                                    </div>
                                    <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
                                        <TextField
                                            style={{ width: '50%' }}
                                            id="len"
                                            label="Length"
                                            type="number"
                                            value={this.state.len}
                                            onChange={this.handleChange}
                                        />
                                        <TextField
                                            style={{ width: '50%' }}
                                            id="width"
                                            label="Width"
                                            type="number"
                                            value={this.state.width}
                                            onChange={this.handleChange}
                                        />
                                    </div>
                                    <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
                                        <FormControlLabel
                                            label={"Online Reservable"}
                                            control={
                                                <Checkbox
                                                    id="remote"
                                                    checked={this.state.remote}
                                                    onChange={this.handleChange}
                                                />
                                            }
                                        />
                                        <FormControlLabel
                                            label={"Active"}
                                            control={
                                                <Checkbox
                                                    id="active"
                                                    checked={this.state.active}
                                                    onChange={this.handleChange}
                                                />
                                            }
                                        />
                                    </div>
                                    <div style={{ display: 'flex', alignItems: 'center', gap: '16px', whiteSpace: "pre-wrap", wordWrap: "break-word" }}>
                                        <TextareaAutosize id="special_condition" placeholder="Space Description" onChange={this.handleChange} value={this.state.special_condition} />
                                    </div>
                                    <div>
                                        <Collapse in={isOpen}>
                                            <div style={{marginBottom:"15px", fontFamily: "Roboto, sans-serif", color: "rgba(0, 0, 0, 0.6)", fontSize: "20px" }}>Custom Amenities</div>
                                            <div style={{ display: "flex", flexDirection: "column", gap: "10px", marginTop: "10px" }}>
                                                {custom_descriptions?.map((field, index) => (
                                                <div key={index} style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                                                    <Tooltip title="Active"><Checkbox  checked={this.state.selectedDescription.includes(field)} onChange={() => this.handleCheckboxChange(index)} /></Tooltip>
                                                    <TextField
                                                    label={`Amenity ${index + 1}`}
                                                    value={field}
                                                    onChange={(e) => this.handleFieldChange(index, e.target.value)}
                                                    variant="outlined"
                                                    size="small"
                                                    fullWidth
                                                    inputProps={{ maxLength: 30 }}
                                                    // helperText={`${field.length}/30`}
                                                    disabled={editEminities !== index}
                                                    />
                                                    <IconButton onClick={() => this.toggleEditMode(index)}>
                                                        {editEminities === index ? <CheckIcon color="primary" onClick={()=>{this.setState({alertMessage: "Changes saved successfully!",alertType: "success",});}} /> : <EditIcon color="action" />}
                                                    </IconButton>
                                                    <IconButton onClick={() => this.handleRemoveField(index)} disabled={custom_descriptions.length === 1}>
                                                        <DeleteIcon color="error" />
                                                    </IconButton>
                                                </div>))}
                                                <Button style={{width:"30%"}} onClick={this.handleAddField} variant="contained" disabled={custom_descriptions.length >= 10 || (custom_descriptions.length > 0 && custom_descriptions[custom_descriptions.length - 1].trim() === "")}>
                                                    Add Amenity
                                                </Button>
                                            </div>
                                        </Collapse>
                                        <Button onClick={this.toggleCollapse} variant="contained" style={{marginTop:'10px'}}>
                                            {isOpen ? "Hide" : "Custom Amenities"}
                                        </Button>
                                    </div>
                                    <div style={{ display: 'flex', flexDirection: "column", gap: "12px" }}>
                                        <div style={{ fontFamily: "Roboto, sans-serif", color: "rgba(0, 0, 0, 0.6)", fontSize: "20px" }}>Images</div>
                                        <div style={{ display: 'flex', flexDirection: "column", gap: "7px", width: '80%' }}>
                                            {/* <div style={{display:"flex", flexDirection:"row", alignItems:"center", justifyContent:'space-between'}}> <div>Main</div>{this.state?.image_url ? <> <Button variant="text" size='small' onClick={() => window.open("www.google.com", '_blank')} >view</Button> <IconButton aria-label="delete" size="small" onClick={()=>this.setState({image_url:null})}><DeleteIcon fontSize="small" sx={{ color: red[500] }}/></IconButton></>:<Button component="label" role={undefined}  variant="text" tabIndex={-1}  startIcon={<CloudUploadIcon />}>  Upload image  <VisuallyHiddenInput type="file" accept="image/*" onChange={this.handleImageChange1} /></Button>}</div>
                                        {this.state.image_url && <div style={{display:"flex", flexDirection:"row", alignItems:"center", justifyContent:'space-between'}}> <div>Secondary</div>{this.state?.image_url_2 ? <> <Button variant="text" size='small' onClick={() => window.open("www.google.com", '_blank')} >view</Button> <IconButton aria-label="delete" size="small" onClick={()=>this.setState({image_url_2:null})}><DeleteIcon fontSize="small" sx={{ color: red[500] }}/></IconButton></>:<Button component="label" role={undefined}  variant="text" tabIndex={-1}  startIcon={<CloudUploadIcon />}>  Upload image  <VisuallyHiddenInput type="file" accept="image/*" onChange={this.handleImageChange2} /></Button>}</div>} */}
                                            <div style={{ display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "space-between" }}>
                                                <div>Main</div>
                                                {this.state?.image_url ? (
                                                    <>
                                                        {!this.state.image_name_1 && <Button variant="text" size="small" onClick={() => window.open(this.state.image_url, "_blank")}>View</Button>}
                                                        {this.state.image_name_1 && <span>{this.state.image_name_1}</span>}
                                                        <IconButton aria-label="delete" size="small" onClick={() => this.setState({ image_url: null, image_name_1: "" })}>
                                                            <DeleteIcon fontSize="small" sx={{ color: red[500] }} />
                                                        </IconButton>
                                                    </>
                                                ) : (
                                                    <Button component="label" role={undefined} variant="text" tabIndex={-1} startIcon={<CloudUploadIcon />}>
                                                        Upload image
                                                        <VisuallyHiddenInput type="file" accept="image/*" onChange={this.handleImageChange1} />
                                                    </Button>
                                                )
                                                }
                                            </div>
                                            {this.state.image_url && (
                                                <div style={{ display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "space-between" }}>
                                                    <div>Secondary</div>
                                                    {this.state?.image_url_2 ? (
                                                        <>
                                                            {!this.state.image_name_2 && <Button variant="text" size="small" onClick={() => window.open(this.state.image_url_2, "_blank")}>View</Button>}
                                                            {this.state.image_name_2 && <span>{this.state.image_name_2}</span>}
                                                            <IconButton aria-label="delete" size="small" onClick={() => this.setState({ image_url_2: null, image_name_2: "" })}>
                                                                <DeleteIcon fontSize="small" sx={{ color: red[500] }} />
                                                            </IconButton>
                                                        </>
                                                    ) :
                                                        (
                                                            <Button component="label" role={undefined} variant="text" tabIndex={-1} startIcon={<CloudUploadIcon />}>
                                                                Upload image
                                                                <VisuallyHiddenInput type="file" accept="image/*" onChange={this.handleImageChange2} />
                                                            </Button>
                                                        )
                                                    }
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                    {this.state.image_url && <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
                                        <FormControlLabel
                                            label={"Make the Space Images Live"}
                                            control={
                                                <Checkbox
                                                    id="active_image"
                                                    checked={this.state.active_image}
                                                    onChange={this.handleChange}
                                                />
                                            }
                                        />
                                    </div>}
                                    <div style={{ display: 'flex', justifyContent: 'center' }}>
                                        <Button onClick={this.state.editMode ? this.updateSpace : this.addNew} disabled={this.state.editMode ? false : (!this.state.formValid)} style={{ backgroundColor: '#2dcd7a', color: '#000000' }}>{this.state.editMode ? "Update" : "Add"} </Button>
                                        <Button onClick={() => { this.setState({ addNew: false, editMode: false }); this.cancelEdit() }} style={{ backgroundColor: '#FDECEB', color: '#DB3737', marginLeft: '8px' }}>Cancel</Button>
                                    </div>
                                </div>
                            </DialogContent>
                        </Dialog>
                    </> : ""
                }
                <>
                    <TableContainer component={Paper} style={{ width: '97%', margin: '0 auto' }}>
                        <Table>
                            <TableHead>
                                <TableRow>
                                    <TableCell>Space Name</TableCell>
                                    <TableCell>Power 15a</TableCell>
                                    <TableCell>Power 30a</TableCell>
                                    <TableCell>Power 50a</TableCell>
                                    <TableCell>Water</TableCell>
                                    <TableCell>Sewer</TableCell>
                                    <TableCell>Site Type</TableCell>
                                    <TableCell>Price Class</TableCell>
                                    <TableCell>Online Reservable</TableCell>
                                    <TableCell>Space Description</TableCell>
                                    <TableCell>Active</TableCell>
                                    <TableCell>Length</TableCell>
                                    <TableCell>Width</TableCell>
                                    <TableCell>Actions</TableCell>
                                    <TableCell>Images</TableCell>
                                    <TableCell>Amenities</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {this.state.spaces.map((space) => (
                                    <TableRow key={space.id}>
                                        <TableCell>
                                            {space.name}</TableCell>
                                        <TableCell>
                                            {(space.power_15a ? 'Yes' : 'No')}</TableCell>
                                        <TableCell>
                                            {(space.power_30a ? 'Yes' : 'No')}</TableCell>
                                        <TableCell>
                                            {(space.power_50a ? 'Yes' : 'No')}</TableCell>
                                        <TableCell>
                                            {(space.water ? 'Yes' : 'No')}</TableCell>
                                        <TableCell>
                                            {(space.sewer ? 'Yes' : 'No')}</TableCell>
                                        <TableCell>
                                            {space.site_name}</TableCell>
                                        <TableCell>
                                            {space.price_name}</TableCell>
                                        <TableCell>
                                            {(space.remote_reservable ? 'Yes' : 'No')}</TableCell>
                                        <TableCell>
                                            {space.special_condition}</TableCell>
                                        <TableCell>
                                            {(space.active ? 'Yes' : 'No')}</TableCell>
                                        <TableCell>
                                            {space.length}</TableCell>
                                        <TableCell>
                                            {space.width}</TableCell>
                                        <TableCell>


                                            <div>
                                                <Button onClick={() => this.editSpace(space)} className='viewButtons' style={{ backgroundColor: '#d4d4d4', color: 'black', marginBottom: '4px' }}>Edit</Button>
                                                <Button className='viewButtons' onClick={() => this.setState({ deleteId: space.id, confirmOpen: true })}>
                                                    Delete
                                                </Button>
                                            </div>

                                        </TableCell>
                                        <TableCell>
                                            {space.image_url ? <Button type='link' onClick={() => this.setState({ viewImage1: space.image_url, viewImage2: space.image_url_2, viewImage: true })}>View Image</Button> : <Button style={{ color: '#000000' }} onClick={() => this.editSpace(space)}>Upload Image</Button>}
                                        </TableCell>
                                        <TableCell>
                                        {space?.custom_eminities.join(", ")}
                                        </TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </>
            </ThemeProvider>
        );
    }
}

export default withStyles(useStyles)(Spaces);


{/* <TextareaAutosize id="image_url" placeholder="Space Description" onChange={this.handleChange} value={this.state.image_url}/> */ }